import {
  normalizePhieuNhapKhoChiTiet,
  type BienBanKiemNghiemFormFields,
  type PhieuNhapKhoCreateRequest,
  type PhieuNhapKhoFormFields,
  type PhieuNhapKhoUpdateRequest,
  type PhieuNhapKhoVatTuLineInput,
} from '@/types/phieu-nhap-kho';

interface BuildCreatePayloadOptions {
  phieuNhap: PhieuNhapKhoFormFields;
  bienBanKiemNghiem: BienBanKiemNghiemFormFields;
  chiTiet: PhieuNhapKhoVatTuLineInput[];
}

interface BuildUpdatePayloadOptions {
  phieuNhap?: Partial<Omit<PhieuNhapKhoFormFields, 'id_kho' | 'id_hop_dong'>>;
  bienBanKiemNghiem?: Partial<BienBanKiemNghiemFormFields>;
  chiTiet?: PhieuNhapKhoVatTuLineInput[];
}

function filterChiTiet(lines: PhieuNhapKhoVatTuLineInput[]) {
  return lines
    .map(normalizePhieuNhapKhoChiTiet)
    .filter((item): item is NonNullable<typeof item> => item !== null);
}

export function buildPhieuNhapKhoCreatePayload(
  options: BuildCreatePayloadOptions
): PhieuNhapKhoCreateRequest {
  return {
    phieuNhap: options.phieuNhap,
    bienBanKiemNghiem: {
      ...options.bienBanKiemNghiem,
      thanh_phan_hoi_dong:
        typeof options.bienBanKiemNghiem.thanh_phan_hoi_dong === 'string'
          ? options.bienBanKiemNghiem.thanh_phan_hoi_dong
          : JSON.stringify(options.bienBanKiemNghiem.thanh_phan_hoi_dong ?? []),
    },
    chiTiet: filterChiTiet(options.chiTiet),
  };
}

export function buildPhieuNhapKhoUpdatePayload(
  options: BuildUpdatePayloadOptions
): PhieuNhapKhoUpdateRequest {
  const payload: PhieuNhapKhoUpdateRequest = {};

  if (options.phieuNhap && Object.keys(options.phieuNhap).length > 0) {
    payload.phieuNhap = options.phieuNhap;
  }

  if (options.bienBanKiemNghiem) {
    const bbkn = { ...options.bienBanKiemNghiem };

    if (
      bbkn.thanh_phan_hoi_dong !== undefined &&
      bbkn.thanh_phan_hoi_dong !== null &&
      typeof bbkn.thanh_phan_hoi_dong !== 'string'
    ) {
      bbkn.thanh_phan_hoi_dong = JSON.stringify(bbkn.thanh_phan_hoi_dong);
    }

    if (Object.keys(bbkn).length > 0) {
      payload.bienBanKiemNghiem = bbkn;
    }
  }

  if (options.chiTiet) {
    payload.chiTiet = filterChiTiet(options.chiTiet);
  }

  return payload;
}

/** Reject empty update bodies (API returns 422). */
export function isPhieuNhapKhoUpdatePayloadEmpty(
  payload: PhieuNhapKhoUpdateRequest
): boolean {
  return (
    !payload.phieuNhap &&
    !payload.bienBanKiemNghiem &&
    (!payload.chiTiet || payload.chiTiet.length === 0)
  );
}

export type { PhieuNhapKhoVatTuLineInput };
